const initProductlist = function() {
	if( !EN.Supports.touch() ) {
		initHover();
		initSizesLogic();
		initSmartColorButtonsHover();
	}
	initSmartColorButtonsMore();

	const ffProducts = document.querySelector( '.en_mdl_products--ff' );
	if( ffProducts ) {
		document.addEventListener( 'update.ff', ev => {
			if( !EN.Supports.touch() ) {
				initHover();
				initSmartColorButtonsHover();
			}
			initSmartColorButtonsMore();
		} );
	}

	// Set default height and
	window.addEventListener( 'resize', function() {
		document.querySelectorAll( '.en_mdl_products .en_mdl_product' ).forEach( ( product ) => {
			product.dataset.defaultHeight = product.offsetHeight;
		} );
		initSmartColorButtonsMore();
	} );

	function initHover() {
		if( !EN.Supports.touch() ) {
			document.querySelectorAll( '.en_mdl_products .en_mdl_product' ).forEach( ( product ) => {
				let imageView = product.closest( '.en_mdl_products' ).dataset.activeImageView || 'product';

				product.dataset.defaultHeight = product.offsetHeight;
				product.classList.add( 'is_hoverable' );

				product.addEventListener( 'mouseenter', () => {
					if( product.classList.contains( 'is_hoverable' ) ) {
						product.style.height = product.dataset.defaultHeight + 'px';
						hoverImage( product, 'in' );
					}
				} );

				product.addEventListener( 'mouseleave', () => {
					product.style.height = 'auto';
					hoverImage( product, 'out' );
				} );
			} );
		}

		function hoverImage( product, type ) {
			const imageView = product.closest( '.en_mdl_products' ).dataset.activeImageView || 'product'
			const slides = product.querySelectorAll( '.mdl_slider__slide' );
			const bullets = product.querySelectorAll( '.mdl_slider__pager-item' );

			// Check if there is hover image
			if( slides.length < 2 ) return;

			for ( let slide of slides ) {
				slide.classList.remove( 'is-active' );
			}

			for ( let bullet of bullets ) {
				bullet.classList.remove( 'is-active' );
			}

			slides[imageView === 'model' ? ( type === 'in' ? 0 : 1 ) : ( type === 'in' ? 1 : 0 )].classList.add( 'is-active' );
			bullets[imageView === 'model' ? ( type === 'in' ? 0 : 1 ) : ( type === 'in' ? 1 : 0 )].classList.add( 'is-active' );
		}
	}

	function initSizesLogic() {
		document.addEventListener( 'mouseenter', e => {
			if ( e.target === document || !e.target.matches( '.en_mdl_product__color' ) ) {
				return;
			}
			const productColorButton = e.target;
			const sizes = productColorButton.dataset.enSizes;

			if ( sizes ) {
				renderSizes( productColorButton, sizes );
			}
		}, true );

		document.addEventListener( 'mouseleave', e => {
			if ( e.target === document || !e.target.matches( '.en_mdl_product__color' ) ) {
				return;
			}
			const productColorButton = e.target;
			const activeColorButton = productColorButton.parentNode.querySelector( '.en_mdl_product__color.en_is_active' );
			const sizes = activeColorButton.dataset.enSizes;

			if ( sizes ) {
				renderSizes( productColorButton, sizes );
			}
		}, true );

		function renderSizes( productColorButton, sizes ) {
			let sizesOutput = JSON.parse( sizes ).map( function( value ) {
				return '<div class="en_mdl_product__sizes_size">' + value + '</div>';
			} );

			const sizesInnerEl = productColorButton.closest( '.en_mdl_product' ).querySelector( '.en_mdl_product__sizes_inner' );
			if ( sizesInnerEl ) {
				sizesInnerEl.innerHTML = sizesOutput.join( ' ' );
			}
		}
	}

	function initSmartColorButtonsMore() {
		document.querySelectorAll( '.en_mdl_products > .en_mdl_product' ).forEach( ( product ) => {
			const colorButtons = product.querySelectorAll( '.en_mdl_product__color' );
			if( colorButtons.length ) {
				const colorButtonsContainer = product.querySelector( '.en_mdl_product__colors' );
				const colorButtonsMoreLink = product.querySelector( '.en_mdl_product__colors-morelink' );
				const containerWidth = colorButtonsContainer.clientWidth;
				const colorButtonWidth = colorButtons[0].offsetWidth;
				const colorButtonsCount = colorButtons.length;
				const visibleColorButtonsCount = Math.floor( containerWidth / colorButtonWidth ) - 1;
				const moreLinkVisible = colorButtonWidth * colorButtonsCount > containerWidth;

				product.dataset.visibleColorButtonsCount = visibleColorButtonsCount;

				if( moreLinkVisible ) {
					for ( let colorbutton of colorButtons ) {
						colorbutton.classList.remove( 'en_hidden' );
					}

					for( let i = visibleColorButtonsCount; i < colorButtons.length; i++ ) {
						colorButtons[i].classList.add( 'en_hidden' );
					}

					colorButtonsMoreLink.classList.remove( 'en_hidden' );
					colorButtonsMoreLink.innerHTML = '+&nbsp;' + ( colorButtonsCount - visibleColorButtonsCount );
				}
			}
		} );
	}

	function initSmartColorButtonsHover() {
		if( !EN.Supports.touch() ) {
			document.querySelectorAll( '.en_mdl_products > .en_mdl_product' ).forEach( ( product ) => {
				const colorButtons = product.querySelectorAll( '.en_mdl_product__color' );

				product.addEventListener( 'mouseenter', () => {
					for ( let colorbutton of colorButtons ) {
						colorbutton.classList.remove( 'en_hidden' );
					}
				} );

				product.addEventListener( 'mouseleave', () => {
					for ( let i = product.dataset.visibleColorButtonsCount; i < colorButtons.length; i++ ) {
						colorButtons[i].classList.add( 'en_hidden' );
					}
				} );
			} );
		}
	}
}

$( document ).ready( function() {
	initProductlist();
} );
